import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { OrdersPage } from './pages/OrdersPage';
import { NewOrderPage } from './pages/NewOrderPage';
import { NewOrderFlowPage } from './pages/NewOrderFlowPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { ExtinguisherStagePage } from './pages/ExtinguisherStagePage';
import { ClientsPage } from './pages/ClientsPage';
import { UsersPage } from './pages/UsersPage';
import { StatisticsPage } from './pages/StatisticsPage';
import './App.css';

// Static role configurations defined once to avoid re-creating arrays on every render.
const ROLES_ADMIN_RECEPTION = ['admin', 'reception'];
const ROLES_ADMIN_TECHNICIAN = ['admin', 'technician'];
const ROLES_ADMIN_ONLY = ['admin'];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/new"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_RECEPTION}>
                <NewOrderFlowPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/new-legacy"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_RECEPTION}>
                <NewOrderPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/orders/:orderId"
            element={
              <ProtectedRoute>
                <OrderDetailPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/extinguisher/:extId/stage/:stageNum"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_TECHNICIAN}>
                <ExtinguisherStagePage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/clients"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_RECEPTION}>
                <ClientsPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_ONLY}>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/statistics"
            element={
              <ProtectedRoute allowedRoles={ROLES_ADMIN_ONLY}>
                <StatisticsPage />
              </ProtectedRoute>
            }
          />
          
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
